/* OCD: on Boost product grids, "Choose options" on a builder deck goes to the
   product page instead of Boost's quick view popup, so the deck passes through
   the deck builder. Decks tagged "Old School" or "no-builder" (reissues, wall
   hangers) and all non-deck products keep the popup. */
(function(){
  'use strict';
  var tagCache={};
  var KEY='ocdDeckTags';
  try{ tagCache=JSON.parse(sessionStorage.getItem(KEY)||'{}')||{}; }catch(e){ tagCache={}; }
  function remember(handle,skip){ tagCache[handle]=skip?1:0; try{ sessionStorage.setItem(KEY,JSON.stringify(tagCache)); }catch(e){} }
  function isSkipTag(t){ t=String(t).toLowerCase(); return t.indexOf('old school')!==-1 || t==='no-builder'; }

  function handleFrom(href){ var m=(href||'').match(/\/products\/([^\/?#]+)/); return m?m[1]:null; }
  function cardInfo(card){
    var link=card.querySelector('a.boost-sd__product-link[href]'); if(!link) return null;
    var title=(link.getAttribute('aria-label')||link.textContent||'').trim();
    if(!/\bdeck\s*$/i.test(title)) return null;
    var handle=handleFrom(link.getAttribute('href')); if(!handle) return null;
    return { link:link, handle:handle };
  }
  function markCard(card){
    if(card.hasAttribute('data-ocd-checked')) return;
    card.setAttribute('data-ocd-checked','1');
    var info=cardInfo(card); if(!info) return;
    if(tagCache[info.handle]!==undefined){ if(!tagCache[info.handle]) card.setAttribute('data-ocd-builder','1'); return; }
    fetch('/products/'+info.handle+'.js',{credentials:'same-origin'}).then(function(r){ return r.ok?r.json():null; }).then(function(p){
      if(!p) return;
      var skip=(p.tags||[]).some(isSkipTag);
      remember(info.handle,skip);
      if(!skip) card.setAttribute('data-ocd-builder','1');
    }).catch(function(){});
  }
  function scan(root){
    var cards=(root||document).querySelectorAll('.boost-sd__product-item');
    for(var i=0;i<cards.length;i++) markCard(cards[i]);
  }
  scan(document);
  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){ var added=muts[i].addedNodes; for(var j=0;j<added.length;j++){ if(added[j].nodeType===1) scan(added[j]); } }
  }).observe(document.body,{ childList:true, subtree:true });

  document.addEventListener('click',function(e){
    var btn=e.target.closest('button, a'); if(!btn) return;
    if(!/choose\s*options/i.test(btn.textContent||'')) return;
    var card=btn.closest('.boost-sd__product-item[data-ocd-builder]'); if(!card) return;
    var link=card.querySelector('a.boost-sd__product-link[href]'); if(!link) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.location.href=link.getAttribute('href');
  },true);
})();